import React from 'react'
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import OptimizedImage from "./OptimizedImage";

const HomeSection4 = ({ section4, WeOfferInView, i18n }) => {
    const __bgEnabled = Number(section4.use_bg_color) === 1 && section4.bg_color1 && section4.bg_color2;
    console.log('Section4 background', {
        use_bg_color: Number(section4.use_bg_color),
        bg_color1: section4.bg_color1,
        bg_color2: section4.bg_color2,
        enabled: __bgEnabled
    });
    return (
        <div>
            {/* <!-- ===== Services WHAT CAN WE OFFER ===== --> */}
            <div className="hero-wrapper position-relative">
                <section className="we-offer py-5" style={Number(section4.use_bg_color) === 1 && section4.bg_color1 && section4.bg_color2 ? { background: `linear-gradient(to right, ${section4.bg_color1}, ${section4.bg_color2})` } : {}}>
                    <div className="container">
                        <div className="row mb-5">
                            <div className="col">
                                <motion.h2
                                    className="fw-bold text-white"
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 1 }}
                                >
                                    {i18n.language === "en" ? section4.titleHeadEn : section4.titleHeadAr}
                                </motion.h2>
                            </div>
                        </div>

                        <div className="row g-4">
                            {section4?.cardData?.map((offer, index) => (
                                (() => {
                                    const __cardEnabled = Number(offer.use_color) === 1 && offer.color1 && offer.color2;
                                    console.log('Section4 card', {
                                        index,
                                        id: offer.id,
                                        use_color: Number(offer.use_color),
                                        color1: offer.color1,
                                        color2: offer.color2,
                                        color: offer.color,
                                        enabled: __cardEnabled
                                    });
                                    return null;
                                })(),
                                <motion.div
                                    key={offer.id}
                                    className={`col-12`}
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.8, delay: index * 0.2 }}
                                >
                                    <div
                                        className="card mb-3 we-offer-card"
                                        style={{
                                            display: "flex",
                                            flexDirection: window.innerWidth < 768
                                                ? "column" // على الموبايل العمودي
                                                : i18n.language === "ar"
                                                    ? index % 2 === 0
                                                        ? "row-reverse" // الكرت الزوجي: الصورة على اليسار
                                                        : "row"       // الكرت الفردي: الصورة على اليمين
                                                    : index % 2 === 0
                                                        ? "row"       // الإنجليزية الكرت الزوجي: الصورة على اليمين
                                                        : "row-reverse", // الكرت الفردي: الصورة على اليسار,
                                            background: (Number(offer.use_color) === 1 && offer.color1 && offer.color2)
                                                ? `linear-gradient(to right, ${offer.color1}, ${offer.color2})`
                                                : (offer.color ? offer.color : "linear-gradient(rgba(187, 255, 214, 0.9), rgba(214, 214, 214, 0.7))"),
                                            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
                                            borderRadius: "30px",
                                            border: "1px"
                                        }}
                                    >
                                        <div className="col-md-4 p-3">
                                            <OptimizedImage
                                                src={offer.img}
                                                className="img-fluid"
                                                alt={offer.titleEn}
                                                width={640}
                                                height={360}
                                                style={{ width: "100%", height: "auto", objectFit: "cover", borderRadius: "30px" }}
                                            />
                                        </div>
                                        <div className="col-md-8">
                                            <div className="card-body">
                                                <h5 className="card-title"> {i18n.language === "en" ? offer.titleEn : offer.titleAr} </h5>
                                                <p className="card-text"> {i18n.language === "en" ? offer.descriptionEn : offer.descriptionAr} </p>
                                                {/* <p className="card-text"><small className="text-muted">Last updated {offer.lastUpdated}</small></p> */}
                                                {/* <div className="circle-offer" style={{
                                                    left: i18n.language === "ar" ? "40px" : "auto",
                                                    right: i18n.language === "en" ? "40px" : "auto"
                                                }}>

                                                </div> */}
                                                <div className=" padding-5 d-flex align-items-center justify-content-between px-5">
                                                    {offer.btnLink ? (
                                                        <NavLink to={offer.btnLink} className="btnBlueCard text-decoration-none">
                                                            {i18n.language === "en" ? section4.btnEn : section4.btnAr}
                                                        </NavLink>
                                                    ) : (
                                                        <button className="btnBlueCard text-decoration-none" disabled>
                                                            {i18n.language === "en" ? section4.btnEn : section4.btnAr}
                                                        </button>
                                                    )}

                                                    <div style={{
                                                        width: "80px",
                                                        height: "80px",
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        // background: "rgba(255, 255, 255, 0.8)"
                                                    }}>
                                                        <OptimizedImage src={offer.icon} alt={offer.titleEn} className="circleImage-offer" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
                <div className="hero-decoration" style={{ bottom: "-35px", left: "1%" }}>
                    <OptimizedImage src={require("../Images/Group 20.png")} alt="Decoration" width={70} height={40} />
                </div>
            </div>
        </div>
    )
}

export default HomeSection4
